import { iaRa } from 'lib/helpers/utility';

import TransactionTagsCell from 'components/shared/Transactions/components/TransactionTagsCell';

/**
 * Tags cell shared by every transaction-backed table.
 *
 * @param {Object} [options]
 * @param {boolean} [options.readOnly] - Render the pills without add, remove or reorder affordances.
 * @param {Object} [options.query] - React Query keys/object used to patch the row after a write.
 * @param {Function} [options.hideRow] - Given the row data, return true to render an empty cell.
 */
export const buildTransactionTagsColDef = ({
  readOnly = false,
  query = { keys: ['transactions'], object: 'transactions' },
  hideRow
} = {}) => ({
  field: 'tagLinks',
  headerName: 'Tags',
  cellClass: 'no-border',
  minWidth: 300,
  valueFormatter: ({ value }) =>
    iaRa(value)
      .map((tagLink) => tagLink?.tag?.name)
      .join(', '),
  cellRenderer: ({ value, data }) =>
    hideRow?.(data) ? null : (
      <TransactionTagsCell value={value} data={data} readOnly={readOnly} query={query} />
    ),
  sortable: false
});

/**
 * Placement rule for the shared transactions table. Editable in the practice portal only — the
 * admin variants span practices, and both the write path and the tag dropdown resolve a single
 * practice. Returns false for the patient portal so `.filter(Boolean)` drops the column there.
 */
export const transactionTagsColDef = ({
  isFromPractice = false,
  isFromAdminPractice = false,
  isFromAdminPatient = false
} = {}) =>
  (isFromPractice || isFromAdminPractice || isFromAdminPatient) &&
  buildTransactionTagsColDef({ readOnly: !isFromPractice });
